<script>
  import BlockContent from "@movingbrands/svelte-portable-text";
  import LinkMark from "../components/LinkMark.svelte";
  import RichTextImage from "../components/RichTextImage.svelte";
  import FileDocument from "../components/FileDocument.svelte";

  export let content;

  export const customSerializers = {
    types: {
      image: (props) => {
        return {
          component: RichTextImage,
          childNodes: props.children,
          props: {
            ref: props.node.asset._ref,
          },
        };
      },
      fileDocument: (props) => {
        return {
          component: FileDocument,
          childNodes: props.children,
          props: props.node,
        };
      },
    },
    marks: {
      link: (props) => {
        return {
          component: LinkMark,
          childNodes: props.children,
          props: props.mark,
        };
      },
    },
  };
</script>

<div class="rich-text">
  <BlockContent blocks={content} serializers={customSerializers} />
</div>

<style>
  :global(.rich-text h1) {
    font-size: 48px;
    margin: 48px 0;
    font-weight: 200;
  }

  :global(.rich-text h2) {
    font-size: 18px;
    text-transform: uppercase;
    letter-spacing: 0.08rem;
    font-weight: 600;
    margin: 20px 0;
  }

  :global(.rich-text p) {
    font-size: 16px;
    line-height: 24px;
    margin: 0;
    margin-bottom: 20px;
    font-weight: 200;
  }

  @media only screen and (min-width: 600px) {
    :global(.rich-text h2) {
      font-size: 22px;
    }

    :global(.rich-text p) {
      font-size: 18px;
      line-height: 28px;
    }
  }
</style>
